import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Filtros } from './Filtros'
import styles from './Filtros.module.css'
import { useCantidadFiltrosAplicados } from './useCantidadFiltrosAplicados'

export const FiltrosContainer = (props) => {
  const [collapsed, setCollapsed] = useState(true)
  const { isMobile } = useSelector((state) => state.clientData) || {}
  const cantidadFiltrosAplicados = useCantidadFiltrosAplicados(props)

  if (!isMobile) {
    return <Filtros {...props} cantidadFiltrosAplicados={cantidadFiltrosAplicados} />
  }

  return (
    <>
      <div className={`${styles.drawer} ${!collapsed ? styles.drawerOpen : ''}`}>
        <button
          type="button"
          className={styles.drawerHandle}
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? 'Abrir filtros' : 'Cerrar filtros'}
          aria-expanded={!collapsed}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
          </svg>

          <span className={styles.drawerHandleLabel}>Filtros</span>

          <span className={styles.drawerHandleChevron} aria-hidden="true">
            {collapsed ? '▶' : '◀'}
          </span>

          {collapsed && cantidadFiltrosAplicados > 0 && (
            <span className={styles.drawerHandleBadge}>{cantidadFiltrosAplicados}</span>
          )}
        </button>

        <div className={styles.filtrosDrawerBody}>
          <aside className={styles.filtrosDrawer}>
            <Filtros {...props} cantidadFiltrosAplicados={cantidadFiltrosAplicados} />
          </aside>
        </div>
      </div>
      {!collapsed && <div className={styles.overlayMobile} onClick={() => setCollapsed(true)} />}
    </>
  )
}
